<template>
  <div id="app">
    <!-- Header -->
    <el-header class="header">
      <div class="header-content">
        <div class="logo">
          <!-- <img src="@/assets/icon.png" class="logo-icon" alt="51软件下载"> -->
          <span class="logo-text">51软件下载</span>
        </div>
        <el-menu 
          mode="horizontal" 
          class="nav-menu" 
          background-color="transparent" 
          text-color="#1890ff"
          active-text-color="#1890ff"
          :default-active="activeMenu"
          @select="handleMenuSelect"
          :ellipsis="false"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/order-query">订单查询</el-menu-item>
          <el-menu-item index="/about">关于我们</el-menu-item>
          <el-menu-item index="/feedback">意见反馈</el-menu-item>
        </el-menu>
      </div>
    </el-header>

    <!-- Main Content -->
    <div class="main-content">
      <!-- Hero Section -->
      <div class="hero-section">
        <div class="hero-content">
          <div class="hero-left">
            <div class="software-screenshot">
              <img :src="gameData.banner"
                alt="IDM界面" class="idm-interface">
            </div>
          </div>
          <div class="hero-right">
            <div class="software-info">
              <!-- 
              <div class="software-header">
                <img src="https://static.624down.com/admin/profile/upload/2024/01/18/20240118120454553I1Z.jpeg"
                  alt="IDM图标" class="software-icon">
                <h1 class="software-title">IDM-极速下载器</h1>
              </div>

              <div class="software-details">
                <div class="detail-row">
                  <span class="detail-label">软件版本：</span>
                  <span class="detail-value">23.07.180256</span>
                  <span class="detail-label">软件大小：</span>
                  <span class="detail-value">10.3 MB</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">更新时间：</span>
                  <span class="detail-value">2024-12-17</span>
                  <span class="detail-label">应用平台：</span>
                  <span class="detail-value">Win11/Win10/Win</span>
                </div>
              </div> -->
              <div v-if="loading">加载中...</div>
              <div v-else-if="error">{{ error }}</div>
              <div v-else-if="gameData">
                <div class="software-header">
                  <img :src="gameData.icon"
                    alt="IDM图标" class="software-icon">
                  <h1 class="software-title">{{ gameData.name }}</h1>
                </div>
                <div class="software-details">
                  <div class="detail-row">
                    <span class="detail-label">软件版本：</span>
                    <span class="detail-value">{{ gameData.version }}</span>
                    <span class="detail-label">软件大小：</span>
                    <span class="detail-value">{{ gameData.size }}</span>
                  </div>
                  <div class="detail-row">
                    <span class="detail-label">更新时间：</span>
                    <span class="detail-value">{{ gameData.update_time }}</span>
                    <span class="detail-label">应用平台：</span>
                    <span class="detail-value">{{ gameData.platform }}</span>
                  </div>
                </div>
              </div>

              <el-button type="primary" size="large" class="download-btn">
                <el-icon>
                  <Download />
                </el-icon>
                立即下载
              </el-button>

              <p class="download-note">通过51下载软件平台，享高速下载等更多增值权益</p>
            </div>
          </div>
          <div class="action-buttons" style="display: flex; flex-direction: column; align-items: flex-end;">
              <div class="action-btn" @click="goToOrderQuery">
                <el-icon>
                  <Files />
                </el-icon>
                <span>订单查询</span>
              </div>
              <div class="action-btn">
                <el-icon>
                  <Service />
                </el-icon>
                <span>联系客服</span>
              </div>
            </div>
        </div>
      </div>

      <!-- Software Introduction -->
      <div class="intro-section">
        <h2 class="section-title">软件介绍</h2>
        <div v-if="loading">加载中...</div>
              <div v-else-if="error">{{ error }}</div>
              <div v-else-if="gameData">
                <p class="intro-text">
                  {{ gameData.introduce }}
                </p>
              </div>
        <!-- <p class="intro-text">
          Internet Download Manager （IDM）是一个将下载速度提高多达5倍，恢复和提高下载进度的工具。能将由于连接丢失、网络问题、计算机关闭或意外断电而中断的下载全面恢复重新启动。
        </p> -->
      </div>

      <!-- Features Section -->
      <div class="features-section">
        <h2 class="section-title">我们的优势</h2>
        <div class="features-grid">
          <div class="feature-card">
            <div class="feature-icon">
              <img src="https://ext.same-assets.com/3136210061/3075321281.png" alt="一键安装卸载">
            </div>
            <h3 class="feature-title">一键下载安装</h3>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <img src="https://ext.same-assets.com/3136210061/3582853214.png" alt="软件权限管理">
            </div>
            <h3 class="feature-title">软件权限管理</h3>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <img src="https://ext.same-assets.com/3136210061/2458650007.png" alt="多维度的功能">
            </div>
            <h3 class="feature-title">多维度的功能</h3>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <img src="https://ext.same-assets.com/3136210061/1533564936.png" alt="多版本的比较">
            </div>
            <h3 class="feature-title">多版本的比较</h3>
          </div>
        </div>
      </div>

      <!-- Installation Steps -->
      <div class="steps-section">
        <h2 class="section-title">安装步骤</h2>
        <div class="steps-container">
          <div class="step-item">
            <div class="step-number">1</div>
            <div class="step-content">
              <h4 class="step-title">购买软件</h4>
              <div class="step-progress" />
            </div>
          </div>
          <div class="step-item">
            <div class="step-number">2</div>
            <div class="step-content">
              <h4 class="step-title">安装软件</h4>
              <div class="step-progress" />
            </div>
          </div>
          <div class="step-item">
            <div class="step-number">3</div>
            <div class="step-content">
              <h4 class="step-title">启动软件</h4>
              <div class="step-progress" />
            </div>
          </div>
        </div>

        <div class="steps-footer">
          <span class="steps-note">以上都不需要，使用普通方式下载</span>
          <el-button type="primary" class="final-download-btn">立即下载</el-button>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <el-footer class="footer">
      <div class="footer-content">
        <p class="copyright">Copyright©2025 51softdown.cn All rights reserved.</p>
        <div class="footer-links">
          <span>奇安科技有限公司</span>
          <span>豫公网安备 XXXXXXXXXX号</span>
          <span>豫ICP备XXXXXXXXX号</span>
        </div>
      </div>
    </el-footer>
  </div>
</template>

<script setup>
// Ensure all components are properly imported
//import { ElHeader, ElMain, ElCard, ElMenu, ElMenuItem } from 'element-plus'

// Clean up unused imports
import { ref, computed } from 'vue'
// import {
//   Logo,
//   Information,
//   Document,
//   Star,
//   Steps,
//   ArrowDownBold
// } from '@element-plus/icons-vue'
// import { ElMessageBox, ElNotification } from 'element-plus'


// 确保这行导入包含 onMounted
import { onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
// 引入API
import { getGamesByGroupName } from '@/utils/api';

// 定义响应式数据对象存储接口返回数据
const route = useRoute();
const router = useRouter();
const gameData = ref(null);
const loading = ref(false);
const error = ref(null);

// 计算当前激活的菜单项
const activeMenu = computed(() => {
  if (route.path === '/about') {
    return '/about';
  } else if (route.path === '/feedback') {
    return '/feedback';
  }
  return '/';
});

// 菜单选择处理
const handleMenuSelect = (key) => {
  if (key === '/') {
    router.push('/');
  } else if (key === '/idm') {
    router.push('/idm');
  } else if (key === '/order-query') {
    router.push('/order-query');
  } else if (key === '/about') {
    router.push('/about');
  } else if (key === '/feedback') {
    router.push('/feedback');
  }
}

const fetchData = async (groupName) => {
  try {
    console.log('Fetching data for group name:', groupName);
    loading.value = true;
    error.value = null;
    const response = await getGamesByGroupName(groupName);
    
    // 检查接口返回状态
    if (response.code === 0 && response.data) {
      // 处理图片URL中的反引号
      const data = response.data;
      if (data.icon) data.icon = data.icon.replace(/`/g, '');
      if (data.banner) data.banner = data.banner.replace(/`/g, '');
      
      gameData.value = data;

      //console.log('Fetched game data:', gameData.value);
      //console.log(gameData.value.version);
    } else {
      error.value = response.msg || '获取数据失败';
    }
  } catch (err) {
    error.value = '网络请求错误，请稍后重试';
    console.error('请求失败:', err);
  } finally {
    loading.value = false;
  }
};

// 跳转到订单查询页面
const goToOrderQuery = () => {
  router.push('/order-query');
};

// 监听路由参数变化
watch(() => route.params.name, (newName) => {
  console.log('路由参数变化:', newName);
  if (newName) {
    // 直接使用名称作为 groupName 调用接口
    fetchData(newName)
  } else {
    // 如果没有路由参数，使用默认名称（例如"idm"）
    fetchData("idm");
  }
}, { immediate: true })

// 组件挂载时调用
onMounted(() => {
  //fetchData();
});
</script>

<style scoped>
#app {
  min-height: 100vh;
  background: linear-gradient(180deg, #f0f8ff 0%, #e6f3ff 50%, #ffffff 100%);
}

/* Header Styles */
.header-content {
  max-width: 1210px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 10px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  transition: transform 0.3s ease;
}

.logo:hover {
  transform: scale(1.05);
}

.logo-icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
  display: block;
}

.logo-text {
  font-size: 22px;
  font-weight: 700;
  color: #333;
  background: linear-gradient(135deg, #1890ff, #40a9ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: 1px;
  text-shadow: 0 2px 4px rgba(24, 144, 255, 0.1);
}

.nav-menu {
  border: none;
  min-width: 200px; /* 确保菜单有足够的宽度 */
}

.nav-menu .el-menu-item {
  color: #1890ff !important;
  font-weight: 500;
  padding: 0 20px; /* 增加左右内边距 */
  font-size: 16px;
  font-weight: bold;
  font-family: SourceHanSansCN-Bold;
}

.nav-menu .el-menu-item:hover {
  background-color: rgba(24, 144, 255, 0.1) !important;
}

/* Main Content */
.main-content {
  max-width: 1210px;
  margin: 0 auto;
  padding: 20px;
}

/* Hero Section */
.hero-section {
  margin-bottom: 60px;
}

.hero-content {
  display: flex;
  align-items: stretch;
  gap: 60px;
  background: white;
  border-radius: 16px;
  padding: 25px;
  box-shadow: 0 8px 32px rgba(24, 144, 255, 0.1);
  border: 1px solid rgba(24, 144, 255, 0.1);
}

.hero-left {
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 15px;
}

.software-screenshot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
}

.idm-interface {
  width: 100%;
  max-width: 450px;
  border-radius: 8px;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
  object-fit: contain;
  max-height: 100%;
}

.hero-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 25px;
  justify-content: flex-start;
  padding-top: 15px;
}

.software-info {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.software-header {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 30px;
}

.software-icon {
  width: 48px;
  height: 48px;
  border-radius: 8px;
}

.software-title {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.software-details {
  background: #f8fafe;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #e6f3ff;
  margin-bottom: 25px;
}

.detail-row {
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.detail-row:last-child {
  margin-bottom: 0;
}

.detail-label {
  color: #666;
  font-size: 14px;
  min-width: 60px;
}

.detail-value {
  color: #333;
  font-weight: 500;
  font-size: 14px;
  margin-right: 20px;
}

.download-btn {
  width: 180px;
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 24px;
  background: linear-gradient(135deg, #1890ff, #40a9ff);
  border: none;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
  margin-bottom: 25px;
}

.download-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(24, 144, 255, 0.4);
}

.download-note {
  color: #666;
  font-size: 13px;
  margin: 0;
}

.action-buttons {
  display: flex;
  gap: 15px;
}

.action-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 15px 20px;
  border: 1px solid #e6f3ff;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  background: white;
  color: #666;
  font-size: 12px;
}

.action-btn:hover {
  border-color: #1890ff;
  color: #1890ff;
  background: #f0f8ff;
}

/* Section Styles */
.section-title {
  font-size: 22px;
  font-weight: 600;
  color: #333;
  margin-bottom: 30px;
  position: relative;
  padding-left: 16px;
}

.section-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: #1890ff;
  border-radius: 2px;
}

/* Intro Section */
.intro-section {
  margin-bottom: 60px;
}

.intro-text {
  color: #666;
  font-size: 15px;
  line-height: 1.8;
  background: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(24, 144, 255, 0.08);
  border: 1px solid rgba(24, 144, 255, 0.1);
}

/* Features Section */
.features-section {
  margin-bottom: 60px;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 25px;
}

.feature-card {
  background: white;
  padding: 30px 20px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 4px 16px rgba(24, 144, 255, 0.08);
  border: 1px solid rgba(24, 144, 255, 0.1);
  transition: all 0.3s;
}

.feature-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(24, 144, 255, 0.15);
}

.feature-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-icon img {
  width: 100%;
  height: auto;
  max-height: 80px;
  object-fit: contain;
}

.feature-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin: 0;
}

/* Steps Section */
.steps-section {
  margin-bottom: 60px;
}

.steps-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(24, 144, 255, 0.08);
  border: 1px solid rgba(24, 144, 255, 0.1);
}

.step-item {
  display: flex;
  align-items: center;
  gap: 15px;
  flex: 1;
  position: relative;
}

.step-item:not(:last-child)::after {
  content: '';
  position: absolute;
  right: -20px;
  top: 20px;
  width: 40px;
  height: 2px;
  background: #e6f3ff;
}

.step-number {
  width: 40px;
  height: 40px;
  background: #1890ff;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
  flex-shrink: 0;
}

.step-content {
  flex: 1;
}

.step-title {
  color: #333;
  font-size: 15px;
  font-weight: 500;
  margin: 0 0 8px 0;
}

.step-progress {
  height: 3px;
  background: #e6f3ff;
  border-radius: 2px;
  position: relative;
  overflow: hidden;
}

.step-progress::after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 70%;
  background: #1890ff;
  border-radius: 2px;
  animation: progress 2s ease-in-out infinite;
}

@keyframes progress {
  0%, 100% { width: 30%; }
  50% { width: 90%; }
}

.steps-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  padding: 25px 30px;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(24, 144, 255, 0.08);
  border: 1px solid rgba(24, 144, 255, 0.1);
}

.steps-note {
  color: #666;
  font-size: 15px;
}

.final-download-btn {
  background: linear-gradient(135deg, #1890ff, #40a9ff);
  border: none;
  padding: 12px 30px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
}

.final-download-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(24, 144, 255, 0.4);
}

/* Footer */
.footer {
  background: #f8fafe;
  color: #666;
  text-align: center;
  padding: 30px 0 50px 0; /* 顶部30px，底部50px（30px + 20px） */
  height: auto !important;
  border-top: 1px solid #e6f3ff;
}

.footer-content {
  max-width: 1210px;
  margin: 0 auto;
  padding: 0 20px;
}

.copyright {
  margin: 0 0 12px 0;
  font-size: 14px;
  color: #333;
}

.footer-links {
  display: flex;
  justify-content: center;
  gap: 30px;
  font-size: 12px;
  color: #999;
  flex-wrap: wrap;
}

/* Responsive */
@media (max-width: 768px) {
  .hero-content {
    flex-direction: column;
    text-align: center;
    gap: 30px;
  }

  .features-grid {
    grid-template-columns: 1fr;
  }

  .steps-container {
    flex-direction: column;
    gap: 25px;
  }

  .step-item::after {
    display: none;
  }

  .steps-footer {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }

  .footer-links {
    flex-direction: column;
    gap: 10px;
  }

  .detail-row {
    flex-direction: column;
    gap: 8px;
  }

  .detail-value {
    margin-right: 0;
  }
  
  /* 在小屏幕上调整导航菜单 */
  .header-content {
    padding: 0 10px;
  }
  
  .nav-menu {
    min-width: 150px;
  }
  
  .nav-menu .el-menu-item {
    padding: 0 12px;
    font-size: 14px;
  }
}
</style>